import apinode from '../../apinode'

class EmpresasDatabaseService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll() {
    const response = await apinode.get(`/empresas-database/${this.idconta}`)

    return response.data
  }
}

export default new EmpresasDatabaseService()
